import { render, staticRenderFns } from "./SCUMKOHI.vue?vue&type=template&id=4f4eadaa&scoped=true"
import script from "./SCUMKOHI.vue?vue&type=script&lang=js"
export * from "./SCUMKOHI.vue?vue&type=script&lang=js"
import style0 from "./SCUMKOHI.vue?vue&type=style&index=0&id=4f4eadaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4eadaa",
  null
  
)

export default component.exports